import { createContext, useContext } from "react";

type WindowRenderMode = "full" | "contentOnly" | "docked";

export const WindowRenderModeContext = createContext<WindowRenderMode>("full");

/**
 * @deprecated Internal context for the legacy `Window` component.
 * `SlottedWindow` handles `contentOnly` and `docked` modes internally;
 * consumers should not need to read render mode directly.
 * This hook will be removed in Q1 2027.
 */
export function useWindowRenderMode(): WindowRenderMode {
    return useContext(WindowRenderModeContext);
}
